import { createApi } from "@reduxjs/toolkit/query/react";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";

const teamProjectsAPI = createApi({
    reducerPath: "teamProjectsAPI",
    baseQuery: customFetchBase,
    endpoints:(builder)=>({
  
        getAllTeamProjectList:builder.mutation({
           query:(data) =>({
            url:"TeamProject/GetTeamProjectList",
            method:'POST',
            body:transformRequest(data)
           }),
           transformResponse: transformSuccessResponse,
           transformErrorResponse: transformErrorResponse
        }),

        addTeamProject:builder.mutation({
            query:(data)=>({
                url:"TeamProject/AddEditTeamProjects",
                method:'POST',
                body:transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteTeamProject:builder.mutation({
            query:(id)=>({
                url:`/TeamProject/DeleteTeamsProjectsById?id=${id}`,
                method:'DELETE',
                body:transformRequest(id)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAssignTeamListByUserId: builder.query({
            query: () => ({
                url:`TeamProject/GetAssignTeamListByUserId`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
  
})

export const {
    useGetAllTeamProjectListMutation,
    useAddTeamProjectMutation,
    useDeleteTeamProjectMutation,
    useLazyGetAssignTeamListByUserIdQuery
} = teamProjectsAPI;

export default teamProjectsAPI;